{
  "slug": "average-iq-in-argentina",
  "title": "Average IQ in Argentina: what can the data support?",
  "description": "A cautious guide to average-IQ claims about Argentina, including sampling, test comparability, uncertainty, and better ways to read country comparisons.",
  "summary": "There is no single timeless national IQ number for Argentina. Published estimates depend on samples, instruments, years, languages, coverage, and statistical adjustments, so precise rankings require caution.",
  "category": "IQ statistics",
  "sections": [
    {
      "heading": "Why different sources report different numbers",
      "paragraphs": [
        "A study may test schoolchildren, volunteers, online participants, or a regional sample rather than a representative cross-section of the country. Results from different ages, years, instruments, and languages are not automatically comparable.",
        "Some country tables combine measured results with values estimated from neighboring countries or other indicators. Decimal precision does not remove uncertainty in the underlying data."
      ]
    },
    {
      "heading": "Questions to ask before trusting a ranking",
      "paragraphs": [
        "Check who was sampled, when data were collected, which test and norms were used, how language and schooling were handled, how much data were missing, and whether uncertainty intervals are reported.",
        "Educational assessments such as PISA measure particular learned competencies and are not interchangeable with an individually administered IQ test, even when results correlate at group level."
      ]
    },
    {
      "heading": "What a country average cannot tell you",
      "paragraphs": [
        "Group distributions overlap substantially. A national estimate cannot determine the ability of an individual from Argentina or explain causes by itself.",
        "Use transparent, current datasets to discuss education, health, and opportunity without turning a contested estimate into a judgment about people or culture."
      ]
    }
  ],
  "faqs": [
    {
      "question": "What is the average IQ of Argentina?",
      "answer": "No single definitive value exists across all sources. The answer changes with the sample, instrument, year, and statistical method."
    },
    {
      "question": "Can countries be ranked precisely by IQ?",
      "answer": "Not responsibly without comparable representative data and visible uncertainty; many popular rankings do not meet that standard."
    }
  ],
  "related": ["average-iq-by-country", "what-is-the-average-iq", "historical-iq-trends"],
  "sources": [
    {
      "label": "OECD — PISA data and methodology",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ]
}
